module.exports = __webpack_public_path__ + "img/tube-adapter.ca2ec518.png";